import { getConfig } from '@/lib/config'

// If the returnTo also is a domain of our website.url (www.getsetup.io). This means we can returnTo lobby URLs.
export function isValidReturnTo(returnUrl: string): boolean {
  try {
    const { publicRuntimeConfig } = getConfig()
    const environmentHost = new URL(publicRuntimeConfig.website.url).hostname
    const returnToHost = new URL(returnUrl).hostname
    return returnToHost.includes(environmentHost)
  } catch (error) {
    return false
  }
}
